import CommonMember from "../../../components/CommonMember";
import {
  ScheduleAll
} from "../../../API/api";
import DayCalender from '../../../components/newSchedule/DayCalender.vue';
import {
  city
} from "../../../assets/conf/city.conf";
import {
  all
} from "deepmerge";
import imgTitle from "../../../components/newSchedule/imgTitle.vue";
import {
  isThisTypeNode
} from "typescript";
import {
  add
} from "lodash";
import Loading from "../../../components/popup/Loading";
import {
  dateToYMD,dateToHMS
} from '../../../util/util';
import debounce from '../../../util/debounce'
import moment from "moment"
export default {
  name: 'newAddSchedule',
  components: {
    CommonMember,
    DayCalender,
    imgTitle,
    Loading
  },
  data() {
    return {
      meetingValues: {
        name: null,
        type: null,
        agenda: null,
        teamUserList: [],
        userList: [],
        // startTimeArr: [],
        // endTime: null,
        // endTimeArr:[],

        room: null,
        fileType: null,
        teamRecorder: [],
        recorder: [],
        customerId: null,
        projectId: null,
        oterTypeIpt: "",
        hour: 0.5,
        roomType: "内部会议",
        roomDetail: "",
        contactInfo: "",
        userRange: 0,
        groupEmail: "",
        repeatType: 0,
        area: null,
        contactName: '',
        contactSummary: "",
      },
      showContent: true, //控制项目对接人的
      citys: city,
      endTime: null,
      startTime: null,
      showPickTimer: false,
      showPickTimerTwo: false,
      endHour: '',
      currentTime: "",
      timeMultiple: false,
      userOptionList: [],
      chooseTimeType: "date",
      startHour: "",
      showJoinPic: [],
      titlePic: require('../../../assets/images/schedule/addSchduleTitle.jpg'),
      choosePeople: require('../../../assets/images/schedule/choosePeople.png'),
      formParams: {
        methods: "",
      },
      DateOpt: {
        default: {},
        shortcuts: [
          "",
          function () {
            return 1;
          }
        ]
      },
      DateOptEnd: {
        default: {},
        shortcuts: [
          "",
          function () {
            return 1;
          }
        ]
      },
      allCustomer: [],
      allProject: [],
      noProject: [{
        name: "无项目",
        id: 0
      }],
      valueTime: [new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 9, 40)],

      rules: {
        roomType: [{
          required: true,
          message: "请选择会议方式",
          trigger: "change"
        }],
        name: [{
            required: true,
            message: "请输入会议名称",
            trigger: "blur"
          },
          {
            max: 200,
            message: '会议名称最多200个字符',
            trigger: 'change'
          }
        ],
        repeatType: [{
          required: true,
          message: "请选择重复类型",
          trigger: "change"
        }],
        userRange: [{
          required: true,
          message: "请选择是否为全体会议",
          trigger: "change"
        }],
        groupEmail: [],
        roomDetail: [{
          required: true,
          message: "请选择会议地点",
          trigger: "change"
        }],
        room: [{
          required: true,
          message: "请选择会议地点",
          trigger: "change"
        }],
        teamUserList: [{
          required: true,
          message: '请选择人员',
          trigger: "blur"
        }],
        teamRecorder: [{
          required: true,
          message: "请选择会议记录人员",
          trigger: "change"
        }],
        customerId: [{
          required: true,
          message: "请选择品牌",
          trigger: "change"
        }],
        projectId: [{
          required: true,
          message: "请选择项目",
          trigger: "change"
        }],
        agenda: [{
          required: true,
          message: "请输入会议议程",
          trigger: "blur"
        }],
        contactName: [],
        area: [],
        type: [{
          required: true,
          message: "请选择会议类型",
          trigger: "change"
        }]
      },
      weeks: [
        "",
        "10:00",
        "10:30",
        "11:00",
        "11:30",
        "12:00",
        "12:30",
        "13:00",
        "13:30",
        "14:00",
        "14:30",
        "15:00",
        "15:30",
        "16:00",
        "16:30",
        "17:00",
        "17:30",
        "18:00",
        "18:30",
        "19:00",
        "19:30",
      ],
      data: [],
      showMeetingRoom: false,
      showMeetingPeople: false,
      search: {
        search_type: 1,
        date: null,
        date_type: "day",
        id: ""
      },
      searchBottom: {
        search_type: 2,
        date: null,
        date_type: "day",
        id: ""
      },
      meetingRooms: [],
      peopleJoin: [],
      value: '',

      userInfo: {
        name: JSON.parse(localStorage.getItem("userInfo")).userName,
        id: JSON.parse(localStorage.getItem("userInfo")).id,
        headPic: JSON.parse(localStorage.getItem("userInfo")).headPic
      },
      roomList: [],
      calendar: "",
      weekDay: "",
      calendarTwo: "",
      weekDayTwo: "",
      projectConf: {
        page: 1,
        pageSize: 1000,
        customerId: null
      },
      joinMeetingPeople: [],
      oldValue: [],
      showRecorePic: [],
      joinPeopleId: [],
      joinPeopleSchedule: [],
      showJoinPicId: [],
      chooseOneId: null, //刚选的邀请与会人员
      background: ['#F7B500', '#ED0423', '#ED0423'],
      showType: true,
      isLoading: false,
      customerConf: {
        page: 1,
        pageSize: 1000
      },
      readOnlyEnd: false,
      roomList: [{
          id: 1,
          name: "会议室1",
          content: "司南",
          disabled: false,
        },
        {
          id: 2,
          name: "会议室2",
          content: "罗盘",
          disabled: false,
        },
        {
          id: 3,
          name: "会议室3",
          content: "方舟",
          disabled: false,
        },
        // {
        //   id: 4,
        //   name: "会议室4",
        //   content: "龙骧",
        //   disabled: false,
        // },
        // {
        //   id: 5,
        //   name: "会议室5",
        //   content: "桂棹",
        //   disabled: false,
        // },
        // {
        //   id: 6,
        //   name: "培训阶梯教室",
        //   content: "岳麓书院",
        //   disabled: false,
        // },
        // {
        //   id: 7,
        //   name: "会议室6",
        //   content: "三翼",
        //   disabled: false,
        // },
        {
          id: 8,
          name: "总经理办公室",
          content: "河朔书院",
          disabled: false,
        },

      ],
      innerStartHour: false,
      innerEndHour: false,
      noFreeReason: [],
      joinPeopleAgain: false,
      repeatName: [],
      submitMeeting:false,
    }
  },
  computed: {
    //会议室禁用
    searchParams() {
      let start = [dateToYMD(this.calendar) + ' ' + this.startHour]
      let end = [dateToYMD(this.calendarTwo) + ' ' + this.endHour]
      let params = {
        start_time: start,
        end_time: end,
      }
      if (this.$route.query.id && this.$route.query.type == "edit") {
        params.editMeetingId = this.$route.query.id
      }
      return params
    },
    //邀请与会人员禁用
    searchPeople() {
      let start = [dateToYMD(this.calendar) + ' ' + this.startHour]
      // calendarTwo
      let end = [dateToYMD(this.calendar) + ' ' + this.endHour]
      let params = {
        start_time: start,
        end_time: end,
        useType: 1,
        // start_time: start,
        // end_time: end,
      }
      if (this.$route.query.id && this.$route.query.type == "edit") {
        params.editMeetingId = this.$route.query.id
      }
      return params
    },
    //不是内部会议并选择品牌
    showAddress() {
      if (this.meetingValues.roomType != '内部会议' && this.meetingValues.customerId) {
        return true
      } else {
        return false
      }
    }
  },

  methods: {
    //选择省市
    handleChange(value) {},
    getAddList() {
      this.meetingValues.roomDetail = "";
      this.meetingValues.area = [];
      let params = {
        waichuType: this.meetingValues.roomType == '本市外出开会' ? 1 : 2,
        roomType: 2,
        customerId: this.meetingValues.customerId
      }
      this.$http
        .post(ScheduleAll.addresslist, this.qs.stringify(params), {
          headers: {
            Authorization: "Bearer " + this.$cookie.get("token")
          }
        }).then(res => {
          if (res.data.retData[0]) {
            let _data = res.data.retData[0]
            this.meetingValues.roomDetail = _data.roomDetail || "";
            this.meetingValues.area = _data.areaList || []

          } else {
            this.meetingValues.roomDetail = "";
            this.meetingValues.area = ""
          }
          this.handleChange(this.meetingValues.area)
          // if(){}
        })
    },
    removeIt(value) {
      setTimeout(() => {
        //如果邀请与会人员删除完了就不显示人员日程
        if (this.showJoinPic == '') {
          this.showMeetingPeople = false
        }
      }, 500)
    },

    showChooseIt(val) {},
    getDetail() {
      this.isLoading = true;
      this.$http
        .post(ScheduleAll.detail, this.qs.stringify({
          id: this.$route.query.id
        }), {
          headers: {
            Authorization: "Bearer " + this.$cookie.get("token")
          }
        })
        .then((res) => {
          if (res.data.retCode === 0) {
            this.meetingValues.roomType = res.data.retData.roomType == 1 ? '内部会议' : res.data.retData.waichuType == 1 ? '本市外出开会' : '异地出差';
            this.meetingValues.roomDetail = res.data.retData.roomDetail;
            this.meetingValues.contactInfo = res.data.retData.contactInfo ?
              JSON.parse(res.data.retData.contactInfo).join(";") :
              "";
            this.meetingValues.groupEmail = res.data.retData.groupEmail ?
              JSON.parse(res.data.retData.groupEmail).join(";") :
              "";
            this.meetingValues.userRange = res.data.retData.userRange;
            this.meetingValues.teamUserList = res.data.retData.teamUserList ?
              JSON.parse(res.data.retData.teamUserList) : [];
            // this.showPic = res.data.retData.userItems;
            this.showJoinPic = res.data.retData.userItems;
            this.showJoinPic = this.showJoinPic.map((item) => {

              return {
                ...item,
                englishName: item.name,
                // userName: item.userName,
              }
            })
            this.teamRecorder = res.data.retData.recorderUserItems;
            this.showRecorePic = res.data.retData.recorderUserItems;
            this.meetingValues.teamRecorder = res.data.retData.teamRecorder ?
              JSON.parse(res.data.retData.teamRecorder) : [];
              this.showJoinPicId=this.showJoinPic.map((item)=>item.id)
              this.oneKeyGet();
            this.meetingValues.agenda = res.data.retData.agenda;
            this.meetingValues.name = res.data.retData.name;
            this.startTime = res.data.retData.startTime.slice(0, 10);
            this.startHour = res.data.retData.startTime.slice(11, 17);
            this.endTime = res.data.retData.endTime.slice(0, 10);
            this.endHour = res.data.retData.endTime.slice(11, 17);
            this.calendar = this.startTime;
            this.calendarTwo = this.startTime;
            //如果是编辑就发送参数
            if (this.$route.query.type) {
              this.getAllteamuser();
            } else {
              //如果是复制就不发送参数
              this.getAllteamuser('params');
            }
            this.getRooms(this.searchParams);
            this.meetingValues.id = res.data.retData.id;
            this.meetingValues.hour = res.data.retData.hour;
            this.meetingValues.room = Number(res.data.retData.room);
            this.meetingValues.type = res.data.retData.type;
            this.choose(this.meetingValues.type);
            if (this.meetingValues.roomType == '异地出差') {
              this.meetingValues.area = res.data.retData.area
              this.meetingValues.roomDetail = res.data.retData.roomDetail
            }
            if (this.showContent && this.meetingValues.roomType != '内部会议') {
              this.meetingValues.contactSummary = res.data.retData.contactSummary
              this.meetingValues.contactName = res.data.retData.contactName
            }
            if (this.meetingValues.roomType != '内部会议') {
              this.rules.teamUserList = [{
                required: false,
                message: '',
                trigger: "blur"
              }];
            }

            this.meetingValues.fileType = res.data.retData.fileType;
            this.meetingValues.userListItems = res.data.retData.userItems;
            this.meetingValues.userList = res.data.retData.userList;
            this.meetingValues.recorderItems = res.data.retData.recorderUserItems;
            this.meetingValues.recorder = res.data.retData.recorder;
            this.changeCustomer(res.data.retData.customerId);
            this.meetingValues.customerId = +res.data.retData.customerId;
            this.meetingValues.projectId = +res.data.retData.projectId;
            this.isLoading = false;
          } else {
            this.isToast = true;
            this.toastMsg = _data.retMsg;
            this.$message.error(`${res.data.retMsg}`);
            this.toastStatus = null;
          }

        })
        .catch()
        .finally(() => {
          this.isLoading = false;
        });
    },
    //逐个与会人员请求接口
    oneKeyGet() {
      let queue = this.showJoinPicId.forEach(item => {
        this.searchBottom = {
          search_type: 2,
          date: this.calendarTwo,
          date_type: "day",
          id: item
        }
        return new Promise(resolve => {
          this.getSchedule(this.searchBottom)
          // .then(res=>{
          //   resolve(res)
          // // this.goOn(item);
          // })
        })
      })
    },
    //前一天后一天
    getDay(newDay, day, type) {
      let dd = new Date(newDay);
      dd.setDate(dd.getDate() + day);
      let y = dd.getFullYear();
      let m =
        dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
      let d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
      if (type == 'top') {
        this.calendar = y + "/" + m + "/" + d;
        this.weekDay =
          "周" + "日一二三四五六".charAt(new Date(this.calendar).getDay());
        this.search.date = this.calendar

        this.getSchedule('top');
      } else if (type == 'bottom') {
        //第二个日历
        this.calendarTwo = y + "/" + m + "/" + d;
        this.weekDayTwo =
          "周" + "日一二三四五六".charAt(new Date(this.calendarTwo).getDay());
        // this.showJoinPicId
        this.joinPeopleSchedule = []
        this.searchBottom = {
          search_type: 2,
          date: this.calendarTwo,
          date_type: "day",
          // id: f[0][1]
        }
        this.oneKeyGet();
      } else {
        this.calendar = y + "/" + m + "/" + d;
        this.weekDay =
          "周" + "日一二三四五六".charAt(new Date(this.calendar).getDay());
        this.calendarTwo = y + "/" + m + "/" + d;
        this.weekDayTwo =
          "周" + "日一二三四五六".charAt(new Date(this.calendarTwo).getDay());
      }
      // this.weekDayTwo =
      // "周" + "日一二三四五六".charAt(new Date(this.calendar).getDay());

    },
    //点击查看邀请与会人员
    lookMeetingPeople() {
      if (this.showJoinPic == '') {
        this.$message({
          message: `${this.meetingValues.roomType == '内部会议' ? '请先选择邀请的与会人员' : '请先选择外出同行人员'}`,
          type: 'warning'
        });
      } else {
        this.showMeetingPeople = !this.showMeetingPeople
        if (this.showMeetingPeople) {
          this.searchBottom = {
            search_type: 2,
            date: this.calendarTwo,
            date_type: "day",
            id: this.joinMeetingPeople.join(',')
          }
          // this.getSchedule('bottom')
        }

      }
    },
    //数组对象去重
    deteleObject(obj) {
      var uniques = [];
      var stringify = {};
      for (var i = 0; i < obj.length; i++) {
        var keys = Object.keys(obj[i]);
        keys.sort(function (a, b) {
          return (Number(a) - Number(b));
        });
        var str = '';
        for (var j = 0; j < keys.length; j++) {
          str += JSON.stringify(keys[j]);
          str += JSON.stringify(obj[i][keys[j]]);
        }
        if (!stringify.hasOwnProperty(str)) {
          uniques.push(obj[i]);
          stringify[str] = true;
        }
      }
      uniques = uniques;
      return uniques;
    },
    newArr(arr) {
      return Array.from(new Set(arr))
    },
    //会议记录人员
    getRecorderPeople(value) {
      setTimeout(() => {
        let choosePeople = this.$refs.recorderContent.panel.getCheckedNodes(value).map((item) => item.data);
        this.showRecorePic = choosePeople;
      }, 100)

    },
    //选择与会人员
    chooseSomePeole(value) {
      console.log(value,'value===')
      //挑出刚选的 
      let oldID = this.joinPeopleId
      this.joinPeopleId = value
      let newId = this.joinPeopleId
      let c = [...oldID, ...newId];
      let d = new Set(c)
      let e = Array.from(d)
      let f = [...e.filter(_ => !oldID.includes(_)), ...e.filter(_ => !newId.includes(_))];
      //选出来了
      this.chooseOneId = f[0][1];
      this.searchBottom = {
        search_type: 2,
        date: this.calendarTwo,
        date_type: "day",
        id: this.chooseOneId
      }
      this.getSchedule('bottom')
      let that = this;
      setTimeout(function () {
        //显示头像

        let showPic = that.$refs.choosePeopleCascader.panel.getCheckedNodes(value).map((item) => item.data);
        that.showJoinPic = showPic.map((item) => {
          return {
            headPic: item.headPic,
            name: item.name,
            id: item.id,
            englishName: item.englishName,
            userName: item.userName,
          }
        });
        //头像去重
        that.showJoinPicId = [];
        for (let i of that.showJoinPic) {
          that.showJoinPicId.push(i.id)
        }

      }, 100)
      //       this.userOptionList.forEach((ele, ind) => {
      //         ele.children.forEach((items)=>{
      // if(this.chooseOneId ==items.id){
      //  this.freeReason= items.isFreeReason
      // }
      //         })
      //       })



    },
    //与会人员头像显示及查询日程
    showPic(value) {

    },
    sureRrepead() {
      this.submitForm('ruleForm')
    },
    //提交
    submitForm(formName) {
      let allPassCon = false;
      this.$refs[formName].validate((valid, obj) => {
        if (valid) {
            let data = JSON.parse(JSON.stringify(this.meetingValues));
            data.contactInfo = data.contactInfo.split(";");
            data.groupEmail = data.groupEmail.split(";");
            data.userList = data.teamUserList.map(e => e[1]);
            data.userList.push(JSON.parse(localStorage.getItem('userInfo')).id)
            // console.log(data.userList,'userlist',data.teamUserList);
            data.recorder = data.teamRecorder.map(e => e[1]);
            if (data.roomType == '内部会议') {
              data.roomType = 1
            } else {
              if (data.roomType == '本市外出开会') {
                data.waichuType = 1
              } else if (data.roomType == '异地出差') {
                data.waichuType = 2
  
              }
              data.roomType = 2
            }
            if (data.repeatType == '0') {
              let startTime = this.startTime.slice(0, 10) + ' ' + this.startHour
              let endTime = this.endTime.slice(0, 10) + ' ' + this.endHour
              let hour = new Date(endTime).getTime() - new Date(startTime).getTime()
              //单次
              if (hour <= 0) {
                allPassCon = false;
                this.$message({
                  message: '会议开始时间要早于会议结束时间',
                  type: 'warning'
                });
                return
              } else {
                allPassCon = true;
                data.startTime = startTime;
                data.endTime = endTime;
                data.hour = (hour) / 1000 / 60 / 60;
                data.startTimeArr = [];
                data.endTimeArr = [];
              }
            } else {
              //判断固定会议时间是否为空
              if (data.startTimeArr == undefined) {
                this.$message({
                  message: '请选择会议的开始时间',
                  type: 'warning'
                });
                allPassCon = false;
                return
              } else if (data.endTimeArr == undefined) {
                this.$message({
                  message: '请选择会议的结束时间',
                  type: 'warning'
                });
                allPassCon = false;
                return
              } else {
                data.startTimeArr = data.startTimeArr.map(e => e + ' ' + this.startHour);
                data.endTimeArr = data.endTimeArr.map(e => e + ' ' + this.endHour);
                //如果开始时间和结束时间的长度不一样
                if (data.startTimeArr.length !== data.endTimeArr.length) {
                  allPassCon = false;
                  this.$message({
                    message: '请选择相同数量的会议开始时间、结束时间',
                    type: 'warning'
                  });
                  return
                  //如果开始时间小于结束时间
                } else if (new Date(data.startTimeArr[0]).getTime() > new Date(data.endTimeArr[0]).getTime()) {
                  this.$message({
                    message: '会议开始时间要早于会议结束时间',
                    type: 'warning'
                  });
                  allPassCon = false;
                  return
                } else {
                  allPassCon = true;
                }
              }
              //固定
  
  
            }
            //如果选择外出开会
            if (data.roomType == 2) {
  
              if (data.roomDetail == '') {
                this.$message({
                  message: '请填写外出城市的具体地址',
                  type: 'warning'
                });
                allPassCon = false;
                return
              } else {
                allPassCon = true;
              }
  
            }
            if (this.meetingValues.agenda.match(/^\s+$/)) {
              this.$message({
                message: '请输入会议议程',
                type: 'warning'
              });
              allPassCon = false
              return
            } else {
              allPassCon = true
            }
            let id = this.showJoinPic.map(item => item.id);
            this.repeatName = []
            this.userOptionList.forEach((ele, ind) => {
              ele.children.forEach((items) => {
                if (id.indexOf(items.id) > -1 && items.isFreeReason.length != 0) {
                  this.repeatName.push(items.name);
                  // items.isFreeReason.map(item=>{
                  //   item.name=items.name
                  //   return item 
                  // });
                  // this.noFreeReason.push(items.isFreeReason)
                  // this.noFreeReason=[...this.noFreeReason,...items.isFreeReason]
                  allPassCon = false;
                  return
                }
  
              })
            })
            if (this.repeatName.length != 0 && this.joinPeopleAgain == false) {
                allPassCon = true;
                let {id,...obj}=data;
                 this.addIt(allPassCon, obj);
            } else {
              this.addIt(allPassCon, data);
            }
        } else {
          for (const prop in obj) {
            if (obj[prop][0].message == '请选择人员') {
              if (this.meetingValues.roomType == '内部会议') {
                obj[prop][0].message = '请选择邀请的与会人员'
              } else {
                obj[prop][0].message = '请选择外出同行人员'
              }
            }
            if (!this.meetingValues[prop] || this.meetingValues[prop].length == 0) {
              this.$message.warning({
                message: obj[prop][0].message,
              });
              break;
            }
          }
          return false;
        }
      });
    },
    // sumit add
    addIt(allPassCon, data) {
      // console.log(allPassCon,data);
      if (allPassCon) {
        let url;
        if (this.$route.query.type) {
          url = ScheduleAll.update
        } else {
          url = ScheduleAll.add
        }
        this.isLoading = true;
        this.joinPeopleAgain = false;
        this.repeatName = [];
        // let url=this.$route.query.type?ScheduleAll.update:ScheduleAll.add;
        this.$http
          .post(url, this.qs.stringify(data), {
            headers: {
              Authorization: "Bearer " + this.$cookie.get("token")
            }
          })
          .then(res => {
            this.isLoading = false;
            let _data = res.data;
            if (_data.retCode === 0) {
              this.isToast = true;
              this.toastMsg = "会议发起成功";
              this.$message({
                message: '会议发起成功',
                type: 'success'
              });
              // this.$message.error(`会议发起成功`);
              this.toastStatus = "success";
              this.$router.push({
                path: '/new/schedule/list'
              })
            } else {
              this.isToast = true;
              this.toastMsg = _data.retMsg;
              this.$message.error(`${_data.retMsg}`);
              this.toastStatus = null;
            }
            setTimeout(() => {
              this.isToast = false;
              this.toastStatus = null;
              this.toastMsg = null;
              if (_data.retCode === 0) {
                // this.$router.push("/schedule/meeting");
              } else if (_data.retCode === 100014) {
                this.$cookie.delete("token");

                this.$router.push("/");
              }
            }, 1500);
          })
          .catch(() => {
            this.isLoading = false;
            this.isToast = true;
            this.toastMsg = "网络错误";
            this.$message.error(`网络错误`);

            this.toastStatus = null;
            setTimeout(() => {
              this.isToast = false;
              this.toastStatus = null;
              this.toastMsg = null;
            }, 1500);
          });
      }
    },
    //选择会议方式
    changeRoomType(value) {
      this.meetingValues.roomDetail = '';
      this.meetingValues.area = '';
      if (value != '内部会议') {
        this.rules.contactName = [{
          required: true,
          message: "请选择项目对接人姓名",
          trigger: "blur"
        }];
        this.rules.room = [];
        this.rules.teamUserList = [{
          required: false,
          message: '',
          trigger: "blur"
        }];;
        //不是内部会议并选择品牌请求会议接口
        if (this.showAddress) {
          this.getAddList();
        }
        if (value == '本市外出开会') {
          this.rules.area = []
          this.rules.roomDetail = [{
            required: true,
            message: "请输入具体地址",
            trigger: "change"
          }]
        } else {
          this.rules.area = [{
            required: true,
            message: "请选择外出城市",
            trigger: "blur"
          }]
        }
      } else {
        this.rules.contactName = [];
        this.rules.area = []
        this.rules.room = [{
          required: true,
          message: "请选择会议地点",
          trigger: "blur"
        }];
        this.rules.teamUserList = [{
          required: true,
          message: '请选择人员',
          trigger: "blur"
        }];

      }
    },

    getRooms(params) {
      this.$http
        .post(ScheduleAll.rooms, this.qs.stringify(params), {
          headers: {
            Authorization: "Bearer " + this.$cookie.get("token")
          },
        })
        .then((res) => {
          let id = []
          for (let i of res.data.retData) {
            id.push(i.id)
          }
          this.roomList.forEach(element => {
            if (id.indexOf(element.id) > -1) {
              element.disabled = false;
            } else {
              element.disabled = true;
              if (this.meetingValues.room == element.id) {
                this.meetingValues.room = null
              }
            }
          })
        });
    },
    getLookUserRoom() {},
    changeProjectId(id) {
      //不是内部会议并选择品牌请求会议接口

    },
    changeCustomer(id) {
      this.meetingValues.projectId = ''
      this.projectConf.customerId = id;
      if (this.showAddress) {
        this.getAddList();
      }
      this.getProject()
    },
    getProject() {
      this.$http
        .post(ScheduleAll.allProject, this.qs.stringify(this.projectConf), {
          headers: {
            Authorization: "Bearer " + this.$cookie.get("token")
          }
        })
        .then(res => {
          const _data = res.data;
          if (_data.retCode === 0) {
            this.allProject = this.noProject.concat(_data.retData.project_list);
          }
        });
    },
    getCustomer() {
      this.$http
        .post(ScheduleAll.allCustomer, this.qs.stringify(this.customerConf), {
          headers: {
            Authorization: "Bearer " + this.$cookie.get("token")
          }
        })
        .then(res => {
          const _data = res.data;
          if (_data.retCode === 0) {
            this.allCustomer = _data.retData.customer_list.data;
          }
        });
    },
    choose(type) {
      this.meetingValues.customerId = '';
      this.meetingValues.projectId = '';
      //选择a-e 所属项目哪种方式都显示） 项目对接人(异地出差）  都没有
      if (type == 'A_DRI落地会/DRI tracking' || type == 'B_共创坊/Work Shop' || type == 'C_公司月会/Monthly Meeting' || type == 'D_团建活动/Team Building' || type == 'E_面试邀请/interview') {
        this.contactName = '';
        this.contactSummary = '';
        this.customerId = '';
        this.projectId = '';
        this.rules.customerId = [];
        this.rules.contactName = [];
        this.showContent = false;

      } else {
        if (this.meetingValues.roomType != '内部会议') {
          this.rules.contactName = [{
            required: true,
            message: "请输入对接人姓名",
            trigger: "blur"
          }];
        } else {
          this.rules.contactName = [];
        }
        this.showContent = true;
        this.rules.customerId = [{
          required: true,
          message: "请选择品牌",
          trigger: "change"
        }];

      }
    },
    //获取所有人
    getAllteamuser(type) {
      //如果是复制会议 首次请求没有条件  如果是修改会议 首次来的有条件
      // let params = type == 'params' ? '' : this.searchPeople
      let params =  this.searchPeople
      console.log(params,'params')
      this.$http
        .post(ScheduleAll.allteamuser, this.qs.stringify(params), {
          headers: {
            Authorization: "Bearer " + this.$cookie.get("token")
          }
        })
        .then(res => {
          const _data = res.data;
          if (_data.retCode === 0) {
            const teamUser = _data.retData.data;
            teamUser.forEach((element, index) => {
              element.value = element.teamId;
              element.label = element.title;
              element.children = element.item;
              element.children.forEach((ele, ind) => {
                ele.value = ele.id;
                ele.label = ele.englishName;
                ele.disabled = ele.isFree == "1" ? false : ele.isFree == "2" ? true : ""
                if (ele.disabled == true) {
                  this.showJoinPicId.splice(this.showJoinPicId.indexOf(ele.id), 1)
                  let j = this.showJoinPic.length; //与会人员头像展示
                  let q = this.meetingValues.teamUserList.length; // 级联选择器邀请与会人员
                  let m = this.showRecorePic.length; //会议记录人员头像
                  let n = this.meetingValues.teamRecorder.length; // 级联选择器会议记录人员
                  while (j--) {
                    if (ele.id == this.showJoinPic[j].id) {
                      this.showJoinPic.splice(j, 1);
                    }
                  };
                  while (q--) {
                    if (ele.id == this.meetingValues.teamUserList[q][1]) {
                      this.meetingValues.teamUserList.splice(q, 1);
                    }
                  };
                  while (m--) {
                    if (ele.id == this.showRecorePic[m].id) {
                      this.showRecorePic.splice(m, 1);
                    }
                  };
                  while (n--) {
                    if (ele.id == this.meetingValues.teamRecorder[n][1]) {
                      this.meetingValues.teamRecorder.splice(n, 1);
                    }
                  };
                }
              });
            });
            if (this.showJoinPic == '') {
              this.showMeetingPeople = false
            }
            this.userOptionList = teamUser;
          }
        });
    },
    //关键字搜索
    filterMethod(node, key) {
      const key_word = node.data.label;
      const parent_key_word = node.parent.data.label;
      let re = new RegExp(key, "i");
      return re.test(key_word) || re.test(parent_key_word);
    },
    //时间选择
    selectDate(date) {
      //如果刚选择的时间与之前选择的一样就不请求接口 
      if (this.calendar.replace(/-/g, '/') != date.slice(0, 10)) {
        this.calendar = date.slice(0, 10);
        this.weekDay =
          "周" + "日一二三四五六".charAt(new Date(this.calendar).getDay());
        this.search.date = this.calendar
        if (this.showMeetingRoom) {
          this.getSchedule('top');
        }
       
        this.getAllteamuser()
      }
      if (this.calendarTwo != date.slice(0, 10)) {
        this.calendarTwo = date.slice(0, 10);
        this.weekDayTwo =
          "周" + "日一二三四五六".charAt(new Date(this.calendarTwo).getDay());
        this.searchBottom = {
          search_type: 2,
          date: this.calendarTwo,
          date_type: "day",
          // id: f[0][1]
        }
        //没有邀请与会人员的时候
        if (this.showJoinPic != '' && this.showMeetingPeople) {
          this.oneKeyGet();
        }

      }
      let chooseDay = new Date(dateToYMD(this.calendar)).getTime()
      if (this.meetingValues.repeatType == 0) {
        this.DateOptEnd["default"] = {
          disabledDate(date) {
            return date && date.valueOf() < chooseDay - 86400000;
          }
        };
      }


      let _date = date;
      let newDate = [];
      let noTimeDate = [];

      if (date.indexOf("00:00") >= 0) {
        _date = date.replace("00:00", "10:00");
      }

      _date.split(",").forEach(ele => {
        if (newDate.join(",").indexOf(ele.substring(0, 10)) < 0) {
          newDate.push(ele);
        } else {
          let index = newDate.join(",").indexOf(ele.substring(0, 10));
          newDate.splice(index / 17, 1);
        }
      });

      this.startTime = newDate.join(",");
      this.meetingValues.startTimeArr = newDate;
      if (this.meetingValues.repeatType == 1) {
        this.endTime = this.startTime;
        this.meetingValues.endTimeArr = this.meetingValues.startTimeArr;
        let startTimeArr = this.meetingValues.startTimeArr.map(e => e + ' ' + this.startHour);
        let endTimeArr = this.meetingValues.endTimeArr.map(e => e + ' ' + this.endHour);
        let parmars = {
          start_time: startTimeArr,
          end_time: endTimeArr,
        }
        this.getRooms(parmars)
      } else {
        console.log(this.searchParams,'oarm')
        this.getRooms(this.searchParams)
      }

      newDate.forEach(ele => {
        noTimeDate.push(ele.split(" ")[0]);
      });
      // 固定会议最多可选择天数
      if (noTimeDate.length > 4) {
        console.log(noTimeDate.length);
        this.DateOpt["default"] = {
          disabledDate(date) {
            try {
              let _year = date.getFullYear();
              let _month = date.getMonth() + 1;
              if (_month < 10) {
                _month = `0${_month}`;
              }
              let _day = date.getDate();
              if (_day < 10) {
                _day = `0${_day}`;
              }
              let _d = `${_year}-${_month}-${_day}`;
              return noTimeDate.indexOf(_d) < 0;
              throw new Error("");
            } catch (err) {}
          }
        };
      } else {
        this.DateOpt["default"] = {
          disabledDate(date) {
            return false;
          }
        };
      }

      if (new Date(this.startTime).getTime() > new Date(this.endTime).getTime()) {
        // this.endTime = this.startTime
        this.calculateEndTime()
      } else {
        // return false; //第二个大
      }
    },
    calculateEndTime(){
      console.log(this.startTime, 'this.startTime', this.startHour,'this.startHour')
     
      // let haomiaoEnd=new Date(itemStartTime).getTime()+30*60*1000;
      // let itemEndTime=dateToYMD(haomiaoEnd)+' '+dateToHMS(haomiaoEnd)
      // this.endTime=dateToYMD(haomiaoEnd);
      // this.endHour=dateToHMS(haomiaoEnd).slice(0,5);
      let itemStartTime
      //固定会议
      if (this.meetingValues.repeatType==1){
        let startTime = this.startTime.split(',')[0]
        itemStartTime = startTime + " " + this.startHour;
      }else{
        itemStartTime = this.startTime + " " + this.startHour;
        this.endTime = moment(itemStartTime).add(0.5, "hour").format("YYYY-MM-DD");
       
      }
      this.endHour = moment(itemStartTime).add(0.5, "hour").format("HH:mm");
    },
    selectDateEnd(date) {
      if (this.calendarTwo.replace(/-/g, '/') != date.slice(0, 10)) {
        this.getAllteamuser()
      }
      this.calendarTwo = date;
      this.weekDayTwo =
        "周" + "日一二三四五六".charAt(new Date(this.calendar).getDay());
      this.getRooms(this.searchParams)
      let _date = date;
      let newDate = [];
      let noTimeDate = [];
      if (date.indexOf("00:00") >= 0) {
        _date = date.replace("00:00", "10:00");
      }

      _date.split(",").forEach(ele => {
        if (newDate.join(",").indexOf(ele.substring(0, 10)) < 0) {
          newDate.push(ele);
        } else {
          let index = newDate.join(",").indexOf(ele.substring(0, 10));
          newDate.splice(index / 17, 1);
        }
      });

      this.endTime = newDate.join(",");
      this.meetingValues.endTimeArr = newDate;

      newDate.forEach(ele => {
        noTimeDate.push(ele.split(" ")[0]);
      });
      if (this.meetingValues.repeatType == 1) {

      }
      // if (noTimeDate.length > 3) {
      //   this.DateOptEnd["default"] = {
      //     disabledDate(date) {
      //       try {
      //         let _year = date.getFullYear();
      //         let _month = date.getMonth() + 1;
      //         if (_month < 10) {
      //           _month = `0${_month}`;
      //         }
      //         let _day = date.getDate();
      //         if (_day < 10) {
      //           _day = `0${_day}`;
      //         }
      //         let _d = `${_year}-${_month}-${_day}`;
      //         return noTimeDate.indexOf(_d) < 0;
      //         throw new Error("");
      //       } catch (err) { }
      //     }
      //   };
      // } else {
      //   this.DateOptEnd["default"] = {
      //     disabledDate(date) {
      //       return false;
      //     }
      //   };
      // }
    },
    //是否为全体会议
    userRangeChange() {
      this.meetingValues.teamUserList = [];
      this.meetingValues.userList = [];
      this.meetingValues.groupEmail = "";
      this.showJoinPic = [];
      this.showJoinPicId = [];
      // this.showJo
      if (this.meetingValues.userRange == 998) {
        this.rules.groupEmail = [{
          required: true,
          message: "请输入群组邮箱",
          trigger: "change"
        }]
        this.rules.teamUserList = [];
      } else {
        this.rules.groupEmail = []
        this.rules.teamUserList = [{
          required: true,
          message: "请选择人员",
          trigger: "blur"
        }];

      }
    },
    //开始时间、结束时间单选或者多选
    repeatTypeChange(type) {
      this.startTime = '';
      this.endTime = '';
      this.DateOpt["default"] = {
        disabledDate(date) {
          return false;
        }
      };
      if (type == "0") {
        this.readOnlyEnd = false;
        this.chooseTimeType = "date";
        this.timeMultiple = false;
        this.DateOptEnd["default"] = {
          disabledDate(date) {
            return false;
          }
        };
      } else {
        this.chooseTimeType = "dates";
        this.timeMultiple = true;
        this.readOnlyEnd = true;
        this.DateOptEnd["default"] = {
          disabledDate(date) {
            return true;
          }
        };
      }
    },
    //确定开始时间结束时间的小时分钟
    sureStartTime(type) {
      console.log(123)
      // this.getRooms()  
      this.meetingValues.teamUserList=[];
      this.meetingValues.teamRecorder=[];
      switch (type) {
        case 'start':
          this.calculateEndTime();
          this.showPickTimer = false
          break;
        case 'end':
          this.showPickTimerTwo = false
      }
      if (this.meetingValues.repeatType == 1) {
        this.endTime = this.startTime;
        this.meetingValues.endTimeArr = this.meetingValues.startTimeArr;
        let startTimeArr = this.meetingValues.startTimeArr.map(e => e + ' ' + this.startHour);
        let endTimeArr = this.meetingValues.endTimeArr.map(e => e + ' ' + this.endHour);
        let parmars = {
          start_time: startTimeArr,
          end_time: endTimeArr,
        }
        this.getRooms(parmars)
      } else {
        this.getRooms(this.searchParams)

      }
      this.getAllteamuser();
    },
    //选择时间  00  30
    filter(type, options) {
      if (type === 'minute') {
        return options.filter((option) => option % 15 === 0);
      }
      return options;
    },
    //展示选择时分
    showPick(type) {
      if (type == 'start') {
        this.showPickTimer = true;
        this.showPickTimerTwo = false;
      } else if (type == 'end') {
        this.showPickTimerTwo = true;
        this.showPickTimer = false;

      }
    },
    hiddenIt(type) {
      //   if (type == 'start'&& this.innerStartHour==false) {
      //     this.showPickTimer = false;
      //   } else if (type == 'end'&& this.innerEndHour==false) {
      //     this.showPickTimerTwo = false;

      //   }
    },
    //点击查看会议室使用
    lookMeetingUse() {
      this.showMeetingRoom = !this.showMeetingRoom;
      if (this.showMeetingRoom) {
        this.search = {
          search_type: 1,
          date: this.calendar,
          date_type: "day",
          id: "1,2,3,4,5,6,7,8"
        }
        this.getSchedule('top')
      }
    },
    initHour() {
      let dd = new Date();
      this.startTime =dateToYMD(dd).replace(/-/ig,'/');
      this.endTime = dateToYMD(dd).replace(/-/ig,'/');
      let nowHour = parseInt(new Date().getHours())
      let timeArr=['00','15','30','45'];
      let min=new Date().getMinutes()
      console.log(min,'min-----')
      switch(true){
        case  (min> 45):
          this.currentTime = nowHour + 1 + ':' + "00"
          this.startHour = this.currentTime
          // this.endHour = (parseInt(this.currentTime.slice(0, 2))) + ':' + "30"
          console.log('45')
          break;
        case (min > 30 && min <45) :
          console.log('30')
          this.startHour = nowHour + ':' +"45"
        break;
        case (min > 15 && min <30) :
          console.log('15')
          this.startHour = nowHour + ':' +"30"
        break; 
        case (min > 0 && min <15) :
          console.log('00')
          this.startHour = nowHour + ':' +"15"
        break;
        
      }
      this.calculateEndTime();
      this.calendar = this.startTime;
      this.calendarTwo = this.startTime;

      this.getRooms(this.searchParams)
    },
    //时间和开始的地方
    gethoursAndPosition(start,endTime,type){
      let startTime = moment(start);
      let fixTime 
      if(type=='top'){
         fixTime = this.calendar + ' 09:30:00'
      }else if(type=='bottom'){
        fixTime = this.calendarTwo + ' 09:30:00'
      }
      let showStart = moment(fixTime);
      //毫秒数
      let diffStart = startTime.diff(showStart, "minute")
      let startPosition, diffHour
      //如果开始时间晚于于9点半
      if (diffStart > 0) {
        diffHour = (moment(endTime).diff(moment(start), 'minute')) / 60
        startPosition = (moment(start).diff(moment(fixTime), 'milliseconnds')) / 60000 * (5.21 / 3)
      } else {
        diffHour = (moment(endTime).diff(moment(fixTime), 'minute')) / 60
        startPosition = 0
      }
      return [diffHour, startPosition]
    },
    //查看会议室使用
    getSchedule(type) {
      let parmars;
      if (type == 'top') {
        parmars = this.search
      } else {
        parmars = this.searchBottom
      }
      // this.meetingRooms=[];
      this.$http.post(ScheduleAll.allSchedule, this.qs.stringify(parmars), {
        headers: {
          'Authorization': 'Bearer ' + this.$cookie.get('token')
        }
      }).then((res) => {
        let _data = res.data
        if (_data.retCode === 0) {

          if (type == "top") {
            this.meetingRooms = [];
            this.meetingRooms = _data.retData.data.map((item) => {
              let hourAndPosition = this.gethoursAndPosition(item.startTime, item.endTime,'top')
              console.log(hourAndPosition,'hourAndPosition')
              const {startTime,roomContent,roomDetail,roomName,roomType,room,hour,creatorName,time_range}=item;
              return {
                startTime,
                roomContent,
                roomDetail,
                roomName,
                roomType,
                room,
                hour: hourAndPosition[0],
                start: hourAndPosition[1],
                creatorName,
                time_range,
                endTime:item.endTime
              }
            });
          } else {
            
            let list = _data.retData.data.map((item) => {
              let hourAndPosition = this.gethoursAndPosition(item.startTime,item.endTime,'bottom')
              console.log(hourAndPosition,'hourAndPosition')
              return {
                start: hourAndPosition[1],
                hour: hourAndPosition[0],
                name: item.name,
                // 颜色
                dataType: item.dataType == 'meeting' ? '#ED0423' : item.dataType == 'outing' ? '#34D1BF' : item.dataType == 'vacation' ? '#F7B500' : '',
                id: parseInt(_data.retData.param.id)
              }
            });
            this.joinPeopleSchedule = list.concat(this.joinPeopleSchedule);
            this.joinPeopleSchedule = this.joinPeopleSchedule.map((item) => {
              return {
                start: item.start,
                hour: item.hour,
                name: item.name,
                // 动态改变高度
                top: this.showJoinPicId.indexOf(item.id),
                dataType: item.dataType,
                id: item.id
              }
            })
            this.joinPeopleSchedule = this.joinPeopleSchedule.filter((item) => item.top != -1)
            console.log(this.joinPeopleSchedule, 'this.joinPeopleSchedule', this.showJoinPicId,'showJoinPicId')
          
          }
        } else {}
        setTimeout(() => {
          this.isToast = false
        }, 1500)
      })
    },
  },
  async created() {

  },
  async mounted() {
    this.getDay(new Date(), 0, all)
    if (this.$route.query.id) {
      this.showType = false;
      this.getDetail();

    } else {
      this.initHour();
      this.getAllteamuser();
    }

    //获取会议室名称
    //获取当前时间
    //获取所有人
    this.getCustomer(); //获取品牌
  },
}
